import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DndModule } from 'ngx-drag-drop';
import { FiAppearanceSidebarEditWidgetsListComponent } from './widgets-list/widgets-list.component';
import { FiDisableLinksModule } from '../../../shared/fi-directives/disable-links/disable-links.module';
import { WidgetModule } from '../../../widget/widget.module';
import { FiAppearanceSidebarEditComponent } from './sidebar-edit/sidebar-edit.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { UtilitiesModule } from '../../../utilities/utilities.module';
import { FiAppearanceAvailableWidgetsListModule } from '../../available-widgets-list/available-widgets-list.module';
import { FiAppearanceTrashBinModule } from '../../trash-bin/trash-bin.module';
import { FiAppearanceWidgetSettingsWrapModule } from '../../widget-settings-wrap/widget-settings-wrap.module';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';

@NgModule({
    imports: [
        CommonModule,
        DndModule,
        FiDisableLinksModule,
        WidgetModule,
        FiAppTextSharedModule,
        UtilitiesModule,
        FiAppearanceAvailableWidgetsListModule,
        FiAppearanceTrashBinModule,
        FiAppearanceWidgetSettingsWrapModule,
        FiPageHeaderModule,
    ],
    declarations: [FiAppearanceSidebarEditWidgetsListComponent, FiAppearanceSidebarEditComponent],
    exports: [FiAppearanceSidebarEditWidgetsListComponent, FiAppearanceSidebarEditComponent],
})
export class FiAppearanceSidebarEditModule {}
